// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle .cropper-crop-box,.circle .cropper-view-box{border-radius:50%!important}.cropper-view-box{box-shadow:0 0 0 1px #39f;outline:0}.preview{border:0;height:200px;height:150px;margin:0 auto;overflow:hidden;width:200px;width:150px}.circle .preview{border-radius:50%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
